import { createRoot } from 'react-dom/client';
import { configurePodusApi } from '@podus/podus-api';
import { App } from './App';
import './styles/globals.css';

configurePodusApi({
    apiUrl: import.meta.env.VITE_PODUS_API_URL,
    systemKey: import.meta.env.VITE_PODUS_SYSTEM_KEY,
});

createRoot(document.getElementById('root')!).render(<App />);
